import { render } from "./StepWizard4.vue?vue&type=template&id=47ef4c70"
import script from "./StepWizard4.vue?vue&type=script&lang=js"
export * from "./StepWizard4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__